import { Typography, TypographyProps } from "@mui/material";
import { FC } from "react";

const BoldTypography: FC<TypographyProps> = (props) => {
  return (
    <Typography sx={{ ...props.sx, fontWeight: "bold" }} {...props}>
      {props.children}
    </Typography>
  );
};

export default BoldTypography;
